/***************************  COMMON - FOCUS STYLE  ***************************/

export const generateFocusVisibleStyles = (color: String) => ({
  outline: `2px solid ${color}`,
  outlineOffset: 2
});
